import Logger from "../lib/logger";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
const NAME = 'THEME MEGANAV';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
export default function () {
	const header		  = document.getElementById('theme-header');
	const navListItems    = header.querySelectorAll('.theme-header__nav-list-item');
	const searchContainer = document.querySelector('[data-careers-search]');
	const searchToggleBtn = document.querySelector('[data-careers-btn]');
	const desktopSearch   = document.querySelector('.theme-header__search');

	const mobile_nav = {
		nav: document.getElementById("theme-mobile_nav"),
		sub_navs: document.querySelectorAll('.theme-mobile-nav__sub-menu'),
		mobileTablet_menu: document.getElementById("theme-mobile_toggle"),
		mobileTablet_buttons: document.querySelectorAll('.theme-mobile-nav__button'),
		main: document.getElementsByTagName('main')[0],
		footer: document.getElementById('footer'),
		careers_nav: document.getElementById('theme-mobile-nav-careers_nav'),
		setWindowInnerHeightVar: () => { // interior height of the window in pixels
			document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`)
		}
	};

	const search_section = {
		input_field: document.getElementById("mobile-open-roles_input"),
		ALLOWED_CHARS: /[A-Za-z\s0-9_-]+/, // Allowing A-Z, a-z, underscore, spaces, and hyphens
		open_roles_select: document.getElementById("mobile-open-roles_select"),
		locations_select: document.getElementById("mobile-open-roles-locations_select"),
		open_roles_btn: document.getElementById("mobile-open-roles_btn")
	};

	navListItems.forEach(item => {
		item.addEventListener('mouseenter', (e) => {
			header.classList.add('theme-header--expanded');

			if (e.target && e.target.id == 'desktopSearch') {
				desktopSearch.classList.add('theme-header__search--expanded');
			} else {
				desktopSearch.classList.remove('theme-header__search--expanded');

				if (document.querySelector('.searchwp-live-search-results-showing')) {
					document.querySelector('.searchwp-live-search-results-showing').setAttribute('aria-expanded', false);
					document.querySelector('.searchwp-live-search-results-showing').classList.remove('searchwp-live-search-results-showing');
				}
			}
		});
	});

	searchContainer.addEventListener('mouseenter', function onSearchContainerHover() {
		// user is accessing the careers search while hovering the nav but hasn't expanded the meganav
		if (!header.classList.contains('theme-header--expanded')) {
			header.classList.remove('theme-header--careers-only');
		}

		if (header.classList.contains('theme-header--expanded')) {
			header.classList.remove('theme-header--careers-only');
		} else {
			// user is accessing the careers search without interacting with the nav list
			header.classList.add('theme-header--careers-only');
		}
	});

	header.addEventListener('mouseleave', function onHeaderLeave(e) {
		if (e.relatedTarget && jQuery(e.relatedTarget).closest('main').length) {
			header.classList.remove('theme-header--expanded');
			header.classList.remove('theme-header--careers-only');
			desktopSearch.classList.remove('theme-header__search--expanded');

			if (document.querySelector('.searchwp-live-search-results-showing')) {
				document.querySelector('.searchwp-live-search-results-showing').setAttribute('aria-expanded', false);
				document.querySelector('.searchwp-live-search-results-showing').classList.remove('searchwp-live-search-results-showing');
			}
		}

	});

	window.setTimeout(function() {
		if (document.querySelector('.searchwp-live-search-results')) {
			document.querySelector('.searchwp-live-search-results').addEventListener('mouseleave', function(e) {
				if (e.relatedTarget && jQuery(e.relatedTarget).closest('main').length) {
					header.classList.remove('theme-header--expanded');
					header.classList.remove('theme-header--careers-only');
					desktopSearch.classList.remove('theme-header__search--expanded');
					document.querySelector('.searchwp-live-search-results-showing').setAttribute('aria-expanded', false);
					document.querySelector('.searchwp-live-search-results-showing').classList.remove('searchwp-live-search-results-showing');
				}
			});
		}
	}, 500);

	// searchContainer.addEventListener('mouseleave', function onSearchContainerLeave() {
	// 	searchToggleBtn.querySelector('Span').innerText = "Search Careers";
	// 	header.classList.remove('theme-header--careers-only');
	// 	searchContainer.classList.remove('theme-header__careers-search--expanded');
	// 	console.warn(3)
	// });

	searchToggleBtn.addEventListener('click', function onSearchBtnClick() {
		if (searchContainer.classList.contains('theme-header__careers-search--expanded')) {
			searchToggleBtn.querySelector('Span').innerText = "Search Careers";
			searchContainer.classList.remove('theme-header__careers-search--expanded');
		} else {
			searchToggleBtn.querySelector('Span').innerText = "Close Careers";
			searchContainer.classList.add('theme-header__careers-search--expanded');
		}
	});

	/**
	 * onMobileNav --- When main mobile nav item is selected
	 * @param evt
	 */
	header.addEventListener("click", function onMobileNav(evt) {
			const target = evt.target;

			if (target && target.nodeName === "BUTTON") {
				let classes = target.className.split(" ");
				if (classes) {
					// Search for class and react on match
					for (let x = 0; x < classes.length; x++) {
						switch (classes[x]) {
							/**
							 * Toggle mobile/tablet navigation
							 */
							case "theme-mobile-nav__toggle":
								if (mobile_nav.nav.getAttribute('aria-expanded') === 'false') {
									mobile_nav.nav.setAttribute('aria-expanded', 'true');
									document.getElementsByTagName("HTML")[0].classList.add('html--blacked-out');
									mobile_nav.footer.classList.add('theme-footer--blacked-out');

									target.getElementsByTagName('span')[0].classList.remove('out');
									target.getElementsByTagName('span')[0].classList.add('in');
								} else {
									mobile_nav.nav.setAttribute('aria-expanded', 'false');
									document.getElementsByTagName("HTML")[0].classList.remove('html--blacked-out');
									mobile_nav.footer.classList.remove('theme-footer--blacked-out');

									target.getElementsByTagName('span')[0].classList.remove('in');
									target.getElementsByTagName('span')[0].classList.add('out');
								}

								// Close all clam-shells
								mobile_nav.sub_navs.forEach(element => {
									if (element.nodeName === "UL") element.removeAttribute("aria-expanded")
								});
								break;

							/**
							 * Open clam-shell menu (and close open menus)
							 */
							case "theme-mobile-nav__button":
								const siblings = getSiblings(target);
								// Close all clam-shells
								mobile_nav.sub_navs.forEach(element => {
									if (element.nodeName === "UL") element.removeAttribute("aria-expanded")
								});
								siblings.forEach(element => {
									if (element.nodeName === "UL") element.setAttribute("aria-expanded", "true")
								});
								break;
							/**
							 * Open Careers nav (mobile only [toggles display of id="theme-mobile-nav-careers_nav"])
							 */
							case "theme-mobile-nav__careers_btn":
							case "theme-mobile-nav-careers-close__button":
								// alert(target)
								mobile_nav.careers_nav.toggleAttribute("aria-expanded");
								mobile_nav.mobileTablet_menu.toggleAttribute("disabled");
								mobile_nav.careers_nav.hasAttribute("aria-expanded") ? document.querySelector('.theme-mobile-nav__careers_btn').textContent = "CLOSE CAREERS" : document.querySelector('.theme-mobile-nav__careers_btn').textContent = "SEARCH CAREERS";
								// Close all clam-shells
								mobile_nav.sub_navs.forEach(element => {
									if (element.nodeName === "UL") element.removeAttribute("aria-expanded")
								});
								break;
							default:
								break;
						}
					}
				}


			}
		}
		, true);

	/**
	 * Set CSS variable to represent the interior height of the window in pixels upon resize and on init
	 */
	window.addEventListener("resize", mobile_nav.setWindowInnerHeightVar);
	mobile_nav.setWindowInnerHeightVar();

	search_section.input_field.addEventListener("beforeinput", onSearchInput);

	// search_section.open_roles_btn.addEventListener("click", onSearchSubmit);

	/**
	 * onSearchInput --- Remove unwanted search criterion
	 * @param evt
	 */
	function onSearchInput(evt) {
		if (!search_section.ALLOWED_CHARS.test(evt.data)) {
			evt.preventDefault();
		}
	}

	/**
	 * onSearchSubmit --- Check the values for each form element. Replace invalid values with null.
	 * TODO If one of the values equals null, alert the user as to which field needs to be remedied
	 * @param evt
	 */
	/*
	 function onSearchSubmit(evt) {
	 evt.preventDefault();
	 const input = search_section.input_field.value !== '' ? search_section.input_field.value : null;
	 const role  = search_section.open_roles_select.value !== '' && search_section.open_roles_select.value.toLowerCase() !== 'none' ? search_section.open_roles_select.value : null;
	 const loc   = search_section.locations_select.value !== '' && search_section.locations_select.value.toLowerCase() !== 'none' ? search_section.locations_select.value : null;
	 alert(
	 `Input:\u00A0${input}\nRole:\u00A0${role}\nLocation:\u00A0${loc}`
	 )
	 }
	 */
	Logger.log(`${NAME} > loaded`);
}


/**
 * getSiblings --- Get element’s siblings
 * @param elem
 * @returns {*[]}
 */
const getSiblings = function (elem) {
	// Setup siblings array and get the first sibling
	let siblings = [];
	let sibling  = elem.parentNode.firstChild;
	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling
	}
	return siblings;
};
